export default __webpack_public_path__ + "static/media/bb5.2.f8339dc6.png";